module.exports = __webpack_public_path__ + "static/media/Logo@2x.7cb302e9.png";